<template>
  <div class="main-container myorder mt30">
    <!--     <code>    {{ deposit_history }}</code>-->
    <div class="container-fluid device-max-area">
      <div class="row">
        <div class="col-lg-8 col-lg-offset-2">
          <div class="panel panel-default myorders">
            <div class="panel-heading maintitle">
              <h4>Deposit History <span class="pull-right">Total Deposit: {{ customer_deposit_amount }}
                  &#8364;</span></h4>
            </div>
            <div class="panel-body">
              <div class="order-items">
                <div class="row">
                  <div class="col-lg-12 table-responsive">

                    <div class="table-responsive no-border">
                      <table class="table  table-responsive  table-striped checkout-table">
                        <thead>
                          <tr>
                            <th>Deposit ID</th>
                            <th>Amount</th>
                            <th class="text-center">Payment Method</th>
                            <th>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(history ,counter) in deposit_history">
                            <td>
                              <div>
                                #{{history.id}}
                              </div>
                            </td>
                            <td class="text-left"> <b class="base-color"> {{ history.amount.toFixed(2) }}
                                &#8364;</b>
                            </td>
                            <td class="text-center"> {{ history.payment_method }}</td>
                            <td> {{ history.created_at | formatDate }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div></div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
const $ = require('jquery');
window.$ = $;
$(function () {
  $(window)
    .scroll(function () {
      $('nav')
        .toggleClass('scrolled', $(this)
          .scrollTop() > 20);
    });
});

import axios from 'axios';

export default {
  data() {
    return {
      deposit_history: [],
      customer_deposit_amount: 0
    };
  },
  created: function () {
    this.fetchDepositHistory();
  },
  methods: {
    fetchDepositHistory: function () {
      //localStorage.clear();
      let vm = this;
      //vm.$parent.startLoading();
      let token = localStorage.getItem('token');
      let logged_in_user_id = localStorage.getItem('logged_in_user_id');
      //pass  user  id  through  url and  catch  throun  controller
      axios.get(this.globalUrl + "deposit-history/" + logged_in_user_id)
        .then(function (response) {
          vm.deposit_history = response.data.deposit_history;
          if (response.data.deposit_total > 0) {
            vm.customer_deposit_amount = response.data.deposit_total;
          }
        })
        .catch((response) => {

        });
    },
  }
};
</script>
